import { createSelector } from "reselect"
import { get } from "lodash"
import { getAllAvailableRollups, getSelectedGroup as getRollupSelectedGroup } from "helpers/rollups"

const getRawSelectedGroup = state => get(state, "modules.compareTopicSummary.selectedGroup")
const getClassifications = (state) => get(state, "global.data.classifications.data.classifications")
const getSavedGroup = (state, props) => get(props, "savedGroup")
const getSelectedDate = (_, props) => get(props, "selectedDate")

const getAccountRollups = createSelector(getClassifications, classifications => ({
  classifications,
}))
export const getGroups = createSelector(
  [getAccountRollups, getSelectedDate],
  getAllAvailableRollups,
)

export const getSelectedGroup = createSelector(
  [getGroups, getRawSelectedGroup, getSavedGroup],
  getRollupSelectedGroup,
)
